import React from "react";

import aquatribe from "../../assets/aquatribe.png";
import playStore from "../../assets/Play_Store.png";
import iosStore from "../../assets/app_store.png";

import { isAndroid, isIOS } from 'react-device-detect';

const Aquatribe = () => {
  return (
    <div className="aquatribe_wrapper">
      <div className="aqualensTribe_image">
        <img src={aquatribe} alt="" />
        <div className="appStores">
        <a
          className="playStore"
          href="https://play.google.com/store/apps/details?id=com.lenskart.aqualens"
        >
          <img src={playStore} alt="" />
        </a>
        <a
          className="appleStore"
          href="https://apps.apple.com/app/aqualens-contact-lenses/id1671107844"
        >
          <img src={iosStore} alt="" />
        </a>
        </div>
      </div>
    </div>
  );
};

export default Aquatribe;
